import React, { useEffect, useState } from 'react';

/**
 * Full-screen splash shown for ~4s on app load, then a quick zoom + fade-out.
 * Sequence:
 *   0–900ms   → fade-in + subtle scale (image lands)
 *   900–4000  → gentle floating
 *   4000–4600 → rapid scale-up + fade-out (the "تكبير سريع واختفاء" exit)
 *   >4600     → component unmounts
 */
export default function Splash() {
  const [phase, setPhase] = useState('visible'); // 'visible' | 'exiting' | 'gone'

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('exiting'), 4000);
    const t2 = setTimeout(() => setPhase('gone'), 4600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (phase === 'gone') return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-[600ms] ${
        phase === 'exiting' ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ backgroundColor: '#018CB5' }}
      aria-hidden={phase !== 'visible'}
    >
      <img
        src="/splash.jpg"
        alt="قِمَم"
        className={`w-[min(82vw,560px)] h-auto select-none splash-img ${phase === 'exiting' ? 'splash-img-exit' : ''}`}
        draggable={false}
      />
      <style>{`
        @keyframes splashIn {
          0%   { opacity: 0; transform: scale(0.94) translateY(8px); }
          100% { opacity: 1; transform: scale(1)    translateY(0);   }
        }
        @keyframes splashFloat {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(-6px); }
        }
        @keyframes splashOut {
          0%   { opacity: 1; transform: scale(1); }
          100% { opacity: 0; transform: scale(1.55); }
        }
        .splash-img {
          animation:
            splashIn 900ms cubic-bezier(0.16, 1, 0.3, 1) both,
            splashFloat 2.4s ease-in-out 900ms infinite;
          will-change: transform, opacity;
        }
        .splash-img-exit {
          animation: splashOut 600ms cubic-bezier(0.65, 0, 0.35, 1) forwards !important;
        }
        @media (prefers-reduced-motion: reduce) {
          .splash-img,
          .splash-img-exit { animation: none; }
        }
      `}</style>
    </div>
  );
}
